// extracted by mini-css-extract-plugin
module.exports = {"screen":"screen__2NlrOD7h8qChd","block":"block__lP1piwGwPUULz"};